import { useQuery } from "@tanstack/react-query";
import { type SocietyProfileEmailBodyInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/email/[emailHistoryId]";
import { type EmailPreviewOutput } from "shared/api/types/society/[societyId]/profiles/[profileId]/email/[emailHistoryId]";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarModalBody, {
  type PillarModalBodyProps,
} from "shared/components/pillar-modal/NewPillarModalBody";
import TemplateComponent from "shared/components/template/TemplateComponent";
import { SocietyProfileEmailBodySchema } from "shared/yup-validators/schemas/society/[societyId]/profiles/[profileId]/societyProfileEmailSchema";

interface EmailPreviewModalProps extends PillarModalBodyProps<true> {
  initalEmail?: string;
  emailPreviewCallout: () => Promise<EmailPreviewOutput>;
  emailSubmit: (props: SocietyProfileEmailBodyInput) => Promise<void>;
  queryKey: string;
  testid?: string;
}

const EmailPreviewModal = ({
  control,
  queryKey,
  emailPreviewCallout,
  emailSubmit,
  initalEmail,
  testid,
}: EmailPreviewModalProps) => {
  const emailTemplatePreview = useQuery<EmailPreviewOutput | undefined>({
    queryKey: ["emailTemplatePreview", queryKey],
    queryFn: () => emailPreviewCallout(),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    enabled: control.isOpen,
  });

  return (
    <PillarModalBody control={control} title="Send Email" testid={testid}>
      <div className="p-0.5 flex flex-col">
        <div>
          {/* TODO: Use new formik components */}
          <TemplateComponent
            data={{}}
            template={emailTemplatePreview.data?.body}
          />
          <div className="py-4">
            <PillarForm<SocietyProfileEmailBodyInput>
              yupValidation={SocietyProfileEmailBodySchema}
              handleSubmit={async (values) => {
                await emailSubmit({
                  fromEmail: emailTemplatePreview.data?.fromEmail,
                  ccEmail: values.ccEmail,
                  ...values,
                });
                control.setIsOpen(false);
              }}
              overrideInitialValues={{ toEmail: initalEmail }}
              className="space-y-1 mt-1"
            >
              <PillarForm.TextInput
                label="Email"
                name="toEmail"
                testid="email-preview-modal-toEmail"
              />
              <PillarForm.FieldTextArray
                label="CC"
                name="ccEmail"
                testid="email-preview-modal-ccEmail"
              />
              <div className="flex justify-end">
                <PillarForm.LoadingSubmitButton testid="email-preview-modal-send-button">
                  Send
                </PillarForm.LoadingSubmitButton>
              </div>
            </PillarForm>
          </div>
        </div>
      </div>
    </PillarModalBody>
  );
};
export default EmailPreviewModal;
